// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../../SagaBase/PersistentObject';

export abstract class ListVehicleType_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListVehicleType';
  $t: string = 'SagaSchema.ListObjects.ListVehicleType';

  public static GetMembers(): string[] {
    return ['Type', 'Description', 'Abbreviation', 'Icon', 'Id'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListVehicleType_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Type: string;
  public Description: string;
  public Abbreviation: string;
  public Icon: any[];
  public Id: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
